import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Spinner from '../../components/ui/spinner';
import { getLocalStorageItem } from '../../core/utility';
import { useAppSelector } from '../../store';
import { getApplicationList, getTamimList } from '../../store/features/hr/hrSlice';
import { getLeftMenuList } from '../../store/features/hrDetail/hrDetailsSlice';
import { isMacOs } from 'react-device-detect';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles.module.scss';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import GetAppIcon from '@material-ui/icons/GetApp';
import { get } from '../../core/client';

const useStyles = makeStyles(() => ({
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
    },
    tableHeader: {
        backgroundColor: '#000',
        color: '#fff',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    tableRow: {
        backgroundColor: '#000',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#111',
        },
    },
    tableCell: {
        borderBottom: '1px solid #333',
        color: '#fff',
        fontSize: '22px',
        padding: '15px 12px',
        textAlign: 'left',
    },
    button: {
        padding: '5px 10px',
        backgroundColor: '#dddddd4a',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#dddddd4a',
        },
    },
}));

const Tamim = () => {
    const { tamim } = useAppSelector(state => state.hr);
    const classes = useStyles();
    const dispatch = useDispatch();
    const culture = getLocalStorageItem('SelectedLanguage');
    const { words } = useAppSelector((state) => state.localization);
    const [isDownloading, setIsDownloading] = useState<boolean>(false)
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        dispatch(getTamimList());
        dispatch(getLeftMenuList());
        dispatch(getApplicationList());
    }, [culture]);

    useEffect(() => {
        const root = document.getElementById('root');
        if (root) {
            root.style.height = 'auto';
        }

        return () => {
            if (root) {
                root.style.height = '100%';
            }
        }
    }, [])


    useEffect(() => {
        const asideMenuBar = document.getElementById('aside-menu-bar');
        const weatherConditionAndSocialMedia = document.getElementById('wheather-condition-social-media');

        const handleScroll = () => {
            const newScrollPosition = window.scrollY;

            if (newScrollPosition !== scrollPosition) {
                console.log(newScrollPosition)
                setScrollPosition(newScrollPosition);
            }
        };

        window.addEventListener('scroll', handleScroll);

        if (scrollPosition > 200) {
            asideMenuBar?.classList?.remove('asideMenuExpanded');
            asideMenuBar?.classList?.add('burgerMenu');
            weatherConditionAndSocialMedia?.classList?.add('f-hide');
        } else {
            asideMenuBar?.classList?.remove('burgerMenu');
            asideMenuBar?.classList?.add('asideMenuExpanded');
            weatherConditionAndSocialMedia?.classList?.remove('f-hide');
        }

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollPosition]);

    const handleButtonClick = async (id: number) => {
        setIsDownloading(true);
        try {
            const response = await get<any>(`/hr/get-temim-file?id=` + id);
            if (response.result) handleDownload(response.result);
            setIsDownloading(false);
        } catch (error) {
            setIsDownloading(false);
        }
    };

    const handleDownload = (file: any) => {
        const byteCharacters = atob(file.content);
        const byteNumbers = new Uint8Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteNumbers], { type: 'application/pdf' });

        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `${file.name}${file.extension}`;
        document.body.appendChild(a);
        a.click();

        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    return words ? (
        <div id="page-wrapper">
            <div className={isMacOs ? 'news-01 isMacOs' : 'news-01'} id="the-news">
                <div className={styles.wrapper}>
                    <div className={styles['item-container']}>
                        <h1 className={styles.title}>{words && words['WEB.documents']}</h1>
                        <table className={classes.table}>
                            <thead>
                                <tr className={classes.tableHeader}>
                                    <th className={classes.tableCell}>{words && words['WEB.documentName']}</th>
                                    <th className={classes.tableCell}></th>
                                </tr>
                            </thead>
                            <br />
                            <br />
                            <tbody>
                                {tamim.items.map((row) => (
                                    <tr key={row.id} className={classes.tableRow}>
                                        <td className={classes.tableCell}>
                                            <div className={styles['column-container']}>
                                                <div className={styles['icon-container']}>
                                                    <FileCopyIcon />
                                                </div>
                                                <div className={styles['column-text']}>
                                                    <p>{row.name}</p>
                                                    <p style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        {row.extension?.toUpperCase().replace('.', '')}
                                                        <span style={{ fontSize: '1.2em' }}>·</span>
                                                        {row.size}KB
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className={classes.tableCell}>
                                            <div className={styles.download}>
                                                <button
                                                    className={styles.button}
                                                    disabled={isDownloading}
                                                    onClick={() => handleButtonClick(row.id)}
                                                >
                                                    <GetAppIcon />
                                                </button>

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Spinner />
    );
};

export default Tamim;
